class SeafarerBodyMetrics {
    height = '';
    weight = '';
    shoe_size_eur = '';
    overall_size_id = 1;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default SeafarerBodyMetrics;
